<template>
  <div class="container flex" style="margin-bottom: 20px;">
    <left></left>
    <div class="live flex1" style="margin-left: 20px;">
    	<div class="title">
    		购买服务 - <span style="color: #4fa7ff;">订单支付</span>
    	</div>
    	<div class="" style="padding: 30px;display: flex;">
    		<span class="flex1">支付金额   ￥{{price}}</span>
       <span class="wechat btn" @click="getWechatPay">微信支付</span>
        <span class="alipay btn" @click="getAlipay">支付宝支付</span>
    	</div>
    	<div class="line">

    	</div>
   	<div class="paytype flex" style="padding: 30px;" v-if="wxrcode">
    		付款方式
    		<div class="wechat">
    			<img class="rcode" id="myqrious" >
    			<div class="text-center" style="color: #fff;font-size: 18px;padding: 10px 0;">
    				用微信扫码付款
    			</div>
    		</div>
    	<!-- 	<div class="alipay">
    			<img src="../assets/img/rcode.png" class="rcode" >
    			<div class="text-center" style="color: #fff;font-size: 18px;padding: 10px 0;">
    				用支付宝扫码付款
    			</div>
    		</div> -->
    	</div>
		
    </div>
  </div>
</template>

<script>
  import left from './left.vue'
  export default {
    name: 'Footer',
    components:{
      left
    },
    data () {
      return {
          data:'',
          serviceTimeId:this.$route.query.serviceTimeId,
          price:this.$route.query.price,
		  wxrcode:'',
		  timer:''
      }
    },
    methods:{
      getAlipay(){
        let data=new FormData();
            data.append('serviceTimeId',this.serviceTimeId);
            data.append('payType',5);
        this.$axios.post(this.$common.purchaseServiceFormOrder_buyServiceForm,data).then((res)=>{
              if(res.data.code==1){
                  this.form=res.data.data;
                    //   let routerData = this.$router.resolve({path:'/ finance / applyText',query:{htmls:res.data.result}});
                  //     console.log(this.form);
                       const div = document.createElement('div');
                                         div.innerHTML = this.form;
                                        document.body.appendChild(div);
                                        document.forms [0] .submit();
              }
              else {
                alert(res.data.msg)
              }
        })
      },
	  getWechatPay(){
		  let data=new FormData();
		      data.append('serviceTimeId',this.serviceTimeId);
		      data.append('payType',4);
		  this.$axios.post(this.$common.purchaseServiceFormOrder_buyServiceForm,data).then((res)=>{
		        if(res.data.code==1){
					this.wxrcode=true
					setTimeout(()=>{
						this.gennerPic(JSON.parse(res.data.data).codeURL);
						this.timer=setInterval(()=>{
							this.getStatus(JSON.parse(res.data.data).orderId)
						},2*1000)
					},1000)
					
					
		        }
		        else {
		          alert(res.data.msg)
		        }
		  })
	  },
	  getStatus(orderId){
		  this.$axios.get(this.$common.purchaseServiceFormOrder_serviceFormByOrderId+'?orderId='+orderId).then((res)=>{
		        if(res.data.code==1){
		  				clearInterval(this.timer)
		  				alert('订单支付成功');
						this.$router.push('/')	
		  					
		        }
		        else {
		          
		        }
		  })
	  },
	  gennerPic(data){
		  console.log(data)
		  var qrious = new QRious({
		  			element:document.getElementById("myqrious"),// 指定的是图片所在的DOM对象
		  			size:250,									//指定图片的像素大小
		  			level:'H',									//指定二维码的容错级别(H:可以恢复30%的数据)
		  			value:data
		  			//指定二维码图片代表的真正的值
		  	})
	  }
    },
    created(){

    }
  }
</script>

<style scoped>
  .line {
  	height: 1px;
  	background-color: #ccc;
  }
  .wechat{

  	padding: 6px;
  	background-color: #00ac00;
  	color: #fff;
  	border-radius: 6px;
  	margin-left: 15px;
  }
  .alipay  {
  	padding: 6px;
  	background-color: #4fa7ff;
  	color: #fff;
  	border-radius: 6px;
  	margin-left: 30px;
  }
  .rcode{
  	width: 145px;
  	height: 145px;
  }
  .btn {
    display: inline-block;
        padding: 6px 12px;
        margin-bottom: 0;
        font-size: 14px;
        font-weight: normal;
        line-height: 1.42857143;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        -ms-touch-action: manipulation;
        touch-action: manipulation;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-image: none;
        border: 1px solid transparent;
        border-radius: 4px;
        padding: 10px 25px;
            border-radius: 0px;
  }

</style>



// WEBPACK FOOTER //
// src/components/pay.vue